module.exports = __webpack_public_path__ + "img/International Journal of Social Robotics 2020.fce98df9.png";